import { FREQUENCY } from '../../models/DonationFrequency';
import { AMOUNT_INPUT } from '../../models/DonationAmount';
export const FALLBACK_TYPEGUARD_FREQUENCY = {
  name: FREQUENCY.ONE_TIME,
  isVisible: true,
  isDefault: true
};
export const FALLBACK_TYPEGUARD_AMOUNT = {
  name: AMOUNT_INPUT.PRESET_1,
  amount: 0,
  isVisible: true,
  isDefault: true
};
export const DEFAULT_FREQUENCIES = [{
  name: FREQUENCY.ONE_TIME,
  isVisible: true,
  isDefault: true
}, {
  name: FREQUENCY.DAILY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.WEEKLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.BI_WEEKLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.MONTHLY,
  isVisible: true,
  isDefault: false
}, {
  name: FREQUENCY.QUARTERLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.SEMI_ANNUALLY,
  isVisible: false,
  isDefault: false
}, {
  name: FREQUENCY.YEARLY,
  isVisible: false,
  isDefault: false
}];
export const DEFAULT_ONE_TIME_AMOUNTS = [{
  name: AMOUNT_INPUT.PRESET_1,
  amount: 500,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_2,
  amount: 100,
  isVisible: true,
  isDefault: true
}, {
  name: AMOUNT_INPUT.PRESET_3,
  amount: 50,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.OTHER,
  amount: 0,
  isVisible: true,
  isDefault: false
}];
export const DEFAULT_RECURRING_AMOUNTS = [{
  name: AMOUNT_INPUT.PRESET_1,
  amount: 50,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.PRESET_2,
  amount: 25,
  isVisible: true,
  isDefault: true
}, {
  name: AMOUNT_INPUT.PRESET_3,
  amount: 10,
  isVisible: true,
  isDefault: false
}, {
  name: AMOUNT_INPUT.OTHER,
  amount: 0,
  isVisible: true,
  isDefault: false
}];